/* unplugin-vue-components disabled */import script from "./TableContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableContent.vue?vue&type=script&lang=ts&setup=true"

import "./TableContent.vue?vue&type=style&index=0&id=ccd0aa6c&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccd0aa6c"]])

export default __exports__